import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const RequestsIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Support</title>
    <path d="M15.9,11.23a4,4,0,1,1-4-4,4,4,0,0,1,4,4m-4,8a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0,12a4,4,0,1,0,4,4,4,4,0,0,0-4-4m28-22h-20v4h20Zm0,12h-20v4h20Zm0,12h-20v4h20Z" />
  </IconBase>
);
